module.exports = __webpack_public_path__ + "static/img/11.ebd92e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/11.png
// module id = M0AI
// module chunks = 0